import React, { useState, useEffect } from "react";
// import "../App.css";
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import ParallaxSection from '../components/ParallaxSection'
import CareerBanner from "../components/Career/CareerBanner";
import CareerFounder from "../components/Career/CareerFounder";
import CareersSection from "../components/Career/CareersSection";
import CareerApplicationForm from "../components/Career/CareerApplicationForm";
import ApplicationProcess from "../components/Career/ApplicationProcess";
import LeaderDivisionSection from "../components/Leadership/LeaderDivisionSection";
import LeaderBuildWithUs from "../components/Leadership/LeaderBuildWithUs";
import QuickAccessRow from "../components/Career/QuickAccessRow";
import WhyPeople from "../components/Career/WhyPeople";
import CareerTexts from "../components/Career/CareerTexts";
import builderpeople from "../Assets/career/merged_no_astronaut.png"
import HeartBanner from "../components/Health/HeartBanner";
import { useLocation, useNavigate } from "react-router-dom";
import builderheart from "../Assets/health/Ellipse 164.png"

const Career = () => {
  const navigate=useNavigate();
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash?.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

const meta = seoMeta["/Career"];
const quickAccessCards = [
  {
    title: "Step Into Opportunity\nGet the Brochure",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Turn Connections\ninto Commissions",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Connecting Talent\nwith Opportunity",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Stay Ahead. Get Hired.\nOn WhatsApp",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

  return (
<>
<Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
          <HeartBanner
                heading="More Than a Job,<br />
          a Journey That Matters."
                subtext="Join a workplace where purpose meets passion, and innovation is driven by values. At VCNR, every role is a chance to uplift communities, and grow alongside bold thinkers"
                buttonText="View Open Roles"
                onButtonClick={() => {
            const el = document.getElementById("careerssection");
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }}
                // heartImageSrc={builderheart}
                peopleImageSrc={builderpeople}
                pulseLineSrc=""
          />
          <div className="section-wrapper sec-bg1" id="BuildingaCulture"><CareerFounder />
          <div id="careerssection"><CareersSection /></div>
          {/* <ParallaxSection><CareerApplicationForm /></ParallaxSection> */}</div>
          <div id="CareerText"><CareerTexts /></div>
         
          <div id="WhyPeopleChooseVCNR"><WhyPeople /></div>
          <div id="ApplicationProcess"><ApplicationProcess /></div>
          {/* <div id="LeaderGallery"><ParallaxSection><LeaderDivisionSection /></ParallaxSection></div> */}
          <div id="BuildCareerWithUs"><ParallaxSection><LeaderBuildWithUs /></ParallaxSection></div>
          <div><ParallaxSection><QuickAccessRow cards={quickAccessCards} /></ParallaxSection></div>
 
    </>
  );
};

export default Career;
